import { TableTotalsFooter } from "../../components/DataTable/TableTotals"
import { useTranslation } from "react-i18next"

import { formatNumber } from "../../utilities/format"

type GeologyRehandleTableFooterProps = {
  totalLoads?: number
  isLoading: boolean
}

const GeologyRehandleTableFooter: React.FC<GeologyRehandleTableFooterProps> = ({
  totalLoads,
  isLoading
}) => {
  const { t } = useTranslation("geology");
  return (
    <TableTotalsFooter
      isLoading={isLoading}
      totals={[{ label: t("totals.loads"), value: formatNumber(totalLoads) }]}
    />
  )
}

export default GeologyRehandleTableFooter
